// extracted by mini-css-extract-plugin
export default {"container":"MultiTouchPopup_container__S4LER","icon":"MultiTouchPopup_icon__RxLBH","content":"MultiTouchPopup_content__Nkb-6","showQr":"MultiTouchPopup_showQr__dhLD0"};